import { useQuery } from '@tanstack/react-query'
import { createApiCall } from 'services'
import type { Role } from 'types'

type InternalRolesResponse = {
  data: Role[]
}

export const useInternalRoles = () => {
  return useQuery<InternalRolesResponse>({
    queryKey: ['roles', 'internal-users'],
    queryFn: async () => {
      const response = await createApiCall({
        method: 'GET',
        url: '/roles/admin/internal-users',
      })

      return response.data as InternalRolesResponse
    },
    staleTime: 1000 * 60 * 5,
  })
}
